/* eslint-disable indent,linebreak-style */
const TABLE_LIMIT = 50;
const tempLevel = true;
const PROJECT_NAME = 'DMH_LIVE_CRM:';

//const tempLevel =  !(!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
const tempDate = new Date();

export default {
  TIME_ZONE: -(tempDate.getTimezoneOffset() / 60),
  DEFAULT_TIME_FORMAT: "DD-MM-YYYY, HH:mm",
  APP_NAME: "Ezupp-Panel",
  DEFAULT_APP_URL: process.env.REACT_APP_API_URL,
  DEFAULT_DOCTOR_URL: process.env.REACT_APP_DOCTOR_API_URL,
  DOCTOR_MOREPEN_URL: process.env.REACT_APP_APP_API_URL,
  DOCTOR_APP_API_URL: process.env.REACT_APP_DOCTOR_API_URL,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  DOCTOR_MOREPEN_WEB_URL: 'https://devupload.d4pcgc9gy26s4.amplifyapp.com',
  // DEFAULT_APP_URL: 'http://35.154.147.169:5055/api/',
  DEFAULT_PAGE_VALUE: TABLE_LIMIT,
  PAGE_VALUE: 10,
  GOOGLE_LOGIN_KEY:
    "1027293586426-qg6lv2vsp57m05tn32m9stku2ljsd1uh.apps.googleusercontent.com",
  GOOGLE_AUTH_KEY:
    "134723802544-4hdevmlr48jv94psl5unmjlpr5m5b1gt.apps.googleusercontent.com",
  // GOOGLE_MAP_KEY: 'AIzaSyDUTIV7DaCvMUMg3qElE-sxdj4zR-dxhFM',
  GOOGLE_MAP_KEY: "AIzaSyA4ZFw4yS0nJW-dOcViHfuQhyUWhgkzUUE",
  FACEBOOK_LOGIN_KEY: "213504989180156",
  DATATABLE_PROPERTIES: {
    title: "Search",
    height: "auto",
    selectable: false,
    showRowHover: true,
    columns: [],
    data: [],
    count: 0,
    page: 0,
    showCheckboxes: false,
    // showHeaderToolbar: true,
    rowsPerPage: TABLE_LIMIT,
    rowsPerPageOptions: [],
  },
  MAP_CENTER: { lat: 28.7383, lng: 77.0822 },
  PRODUCT_TAGS: ["VEG", "VEGAN", "GLUTEN FREE", "DIARY"],
  CURRENCY: "RS.",
  GENERAL_STATUS: {
    PENDING: "PENDING",
    WAITING: "WAITING",
    ACCEPTED: "ACCEPTED",
    ACTIVE: "ACTIVE",
    SUSPENDED: "SUSPENDED",
    ALLOTTED: "ALLOTTED",
    COMPLETED: "COMPLETED",
  },
  STATUS: {
    PENDING: "warning",
    WAITING: "waiting",
    ACCEPTED: "success",
    ACTIVE: "success",
    SUSPENDED: "error",
    ALLOTTED: "success",
    COMPLETED: "success",
  },
  ORDER_STATUS: {
    PENDING: "PENDING",
    ASSIGNED: "ASSIGNED",
    PAYMENT: "PAYMENT",
    ON_PICKUP_LOCATION: "ON_PICKUP_LOCATION",
    OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
    ON_DROP_LOCATION: "ON_DROP_LOCATION",
    DELIVERED: "DELIVERED",
    REJECTED: "REJECTED",
    ACCEPTED: "ACCEPTED",
  },
  ORDER_STATUS_TEXT: {
    ORDER: "Ordered",
    PENDING: "Pending",
    ASSIGNED: "Driver Assigned",
    PAYMENT: "Payment Pending",
    ON_PICKUP_LOCATION: "Dispatching",
    OUT_FOR_DELIVERY: "Out For Delivery",
    ON_DROP_LOCATION: "Arrived On Location",
    DELIVERED: "Order Delivered",
    REJECTED: "Rejected",
    ACCEPTED: "Accepted",
  },
  SOCKET_EVENT: {
    EMIT_TEXT_MESSAGE: PROJECT_NAME + "EMIT_TEXT_MESSAGE",
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    SEND_ROOM_MESSAGE_UPDATE: PROJECT_NAME + "SEND_ROOM_MESSAGE_UPDATE",
    UPDATE_MESSAGE_LIST: PROJECT_NAME + "UPDATE_MESSAGE_LIST",
    UPDATE_JOB_DATA: PROJECT_NAME + "UPDATE_JOB_DATA",
    DISABLE_ROOM_MESSAGE_UPDATE: PROJECT_NAME + "DISABLE_ROOM_MESSAGE_UPDATE",
    ENABLE_ROOM_MESSAGE_UPDATE: PROJECT_NAME + "ENABLE_ROOM_MESSAGE_UPDATE",
    INDIVIDUAL_MESSAGE_CHANNEL: PROJECT_NAME + "INDIVIDUAL_MESSAGE_CHANNEL",
    CONVERSATION_UPDATE: PROJECT_NAME + 'CONVERSATION_UPDATE'
  },
  SOCKET_CHANNELS: {
    NEW_MESSAGE: PROJECT_NAME + "NEW_MESSAGE",
    NEW_CONVERSATION: PROJECT_NAME + "NEW_CONVERSATION",
    CONVERSATION_DELETE: PROJECT_NAME + "CONVERSATION_DELETE",
    INDIVIDUAL_MESSAGE_CHANNEL: PROJECT_NAME + "INDIVIDUAL_MESSAGE_CHANNEL",
    CONVERSATION_UPDATE: PROJECT_NAME + "CONVERSATION_UPDATE",
  },
  SOCKET_EVENTS: {
    NEW_ORDER: "COMPANY_NEW_ORDER",
    ORDER_UPDATE: "COMPANY_ORDER_UPDATE",
    ORDER_ACCEPTED: "ORDER_ACCEPTED",
    ORDER_ASSIGNED: "ORDER_ASSIGNED",
    ORDER_REJECTED: "ORDER_REJECTED",
    ORDER_ON_PICKUP_LOCATION: "ORDER_ON_PICKUP_LOCATION",
    ORDER_ON_WAY: "ORDER_ON_WAY",
    ORDER_ON_DROP_LOCATION: "ORDER_ON_DROP_LOCATION",
    ORDER_DELIVERED: "ORDER_DELIVERED",
    ORDER_LOCATION_UPDATE: "COMPANY_LOCATION_UPDATE",
    ORDER_DATA: "ORDER_DATA",
    COMPANY_DRIVER_ADD: "COMPANY_DRIVER_ADD",
    COMPANY_DRIVER_REMOVE: "COMPANY_DRIVER_REMOVE",
  },
  API_ERROR_OBJ: {
    404: "API error",
    500: "Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
  },
  USER_TYPES: {
    CUSTOMER: "CUSTOMER",
    MANUFACTURE: "MANUFACTURER",
    BOTH: "BOTH",
  },
  PRIORITY_TEXT: {
    HIGH: "Hot Lead",
    MEDIUM: "Warm Lead",
    LOW: "Cold Lead",
  },
  PRIORITY: {
    HIGH: "HIGH",
    MEDIUM: "MEDIUM",
    LOW: "LOW",
  },
  CONCERN_STATUS_TEXT: {
    TRANSACTION_FAILURE: "Transaction Failure",
    ORDER_DISPUTE: "Order Dispute",
    ACCOUNT_RELATED_ISSUE: "Account Related Issue",
    PARTNER_REQUEST: "Partner Request",
    MEDIA_QUERY: "Media Query",
    GENERAL_SUPPORT: "General Support",
    CAREER_OPPORTUNITY: "Career Opportunity",
    OTHER: "Other",
  },
  SUPPORT_STATUS: {
    PENDING: "PENDING",
    RESOLVED: "RESOLVED",
  },
  SUPPORT_STATUS_TEXT: {
    PENDING: "Pending",
    RESOLVED: "Resolved",
  },
  QUOTE_STATUS: {
    PENDING: "PENDING",
    ON_GOING: "ON_GOING",
    CONVERTED: "CONVERTED",
    JUNK: "JUNK",
    COMPLETED: "COMPLETED",
  },
  QUOTE_STATUS_TEXT: {
    PENDING: "Pending",
    ON_GOING: "On Going",
    CONVERTED: "Converted",
    JUNK: "Junk",
    COMPLETED: "Completed",
  },
  QUOTE_STATUS_COLOR: {
    PENDING: "pending",
    ON_GOING: "on_going",
    CONVERTED: "converted",
    JUNK: "junk",
    COMPLETED: "completed",
  },
  INDUSTRY_STATUS_TEXT: {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    PENDING: "COMING SOON",
  },
  PROFILE_TYPE: {
    BUSINESS: "BUSINESS",
    INDIVIDUAL: "INDIVIDUAL",
    NOT_PREFER: "NOT_PREFER",
    FEMALE: "FEMALE",
    MALE: "MALE",
    CARETAKER: "OTHER",
    PATIENT: "SELF"
  },
  DOCTOR_STATUS: {
    PENDING: "PENDING",
    UNDER_REVIEW: "UNDER_REVIEW",
    REJECTED: "INACTIVE",
    ACTIVE: "ACTIVE",
    SUSPENDED: "SUSPENDED",
  },
  PIPELINE_STAGES: {
    QUALIFIED: "Qualified",
    CONTACT_MADE: "Contact Made",
    DEMO_SCHEDULED: "Demo Scheduled",
    PROPOSAL_MADE: "Proposal Made",
    NEGOTIATIONS_STARTED: "Negotiations Started",
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS",
    PROPOSAL_SENT: "PROPOSAL_SENT",
    ARCHIVED: "ARCHIVED",
    CUSTOMER: "CUSTOMER",
    INTERESTED: "INTERESTED",
    NOT_INTERESTED: "NOT_INTERESTED",
    CONVERTED: "CONVERTED",
    ALL: " ",
  },
  MODULES: {
    DASHBOARD: "DASHBOARD",
    LEADS: "LEADS",
    PROFILE: "PROFILE",
    SERVICES: "SERVICES",
    CONTACTS: "CONTACTS",
    CUSTOMER: "CUSTOMER",
    APPOINTMENTS: "APPOINTMENTS",
    WHATS_APP_CHAT: "WHATS_APP_CHAT",
    STAFF_LIST: "STAFF_LIST",
    SHIFTS: "SHIFTS",
    USER_ROLE: "USER_ROLE",
    CALENDAR: "CALENDAR",
    HEALTH_MARKERS: "HEALTH_MARKERS",
    ORDER_LIST: "ORDER_LIST",
    DOCTOR_REQUEST: "DOCTOR_REQUEST",
    REPORTS: "REPORTS",
    HCP: "HCP",
    DOCTORS: "DOCTORS",
    ROLES: "ROLES",
    GEOFENCES: "GEOFENCES",
    APP_ORDERS: "APP_ORDERS",
    FEEDBACK: "FEEDBACK",
    DEMAND_SUPPLY: "DEMAND_SUPPLY"
  },

  LOG_ENABLED: true,
  WARNING_ENABLED: true,
  ERROR_ENABLED: true,
};

export const DR_MOREPEN_API_CREDENTIALS = {
    USERNAME: "prodmorepenhome",
    PASSWORD: "3c06bf544d5c7cbe77b60921",
};
